import { motion, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";

/* Честный блок: кейсов пока нет. Вместо выдуманных историй пустая рамка с пульсирующей
   подсветкой, место под будущий кейс. Тексты прежние. */
export const NoCases = () => {
  const reduce = useReducedMotion();
  return (
    <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-16">
      <Reveal>
        <div className="max-w-[640px] space-y-4 text-lg text-muted">
          <p>
            Практика молодая, и придумывать цифры и отзывы я не буду. Вместо чужих историй ты получаешь свою: разбор
            твоего процесса, с твоими часами и твоими рублями.
          </p>
          <p>Первый кейс будет после первого пилота.</p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="relative">
          <motion.div
            aria-hidden="true"
            className="absolute -inset-6 rounded-[2.5rem] bg-accent/20 blur-3xl"
            animate={reduce ? undefined : { opacity: [0.35, 0.8, 0.35] }}
            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          />
          <div className="relative flex min-h-56 flex-col items-center justify-center gap-3 rounded-3xl border-2 border-dashed border-accent/50 bg-ink-1/40 p-8 text-center backdrop-blur">
            <p className="eyebrow">Место под кейс</p>
            <p className="accent-serif text-3xl sm:text-4xl">первый кейс</p>
            <p className="text-base text-muted">после первого пилота</p>
          </div>
        </div>
      </Reveal>
    </div>
  );
};
